import { usePatientStore } from "@/dentlab/src/store/Patient";
import { useJobStore } from "@/dentlab/src/store/Jobs";
import { showNotification } from "@/dentlab/src/store/Central/selectors";
import { Checkbox } from "@/dentlab/src/components/ui/checkbox";
import { Label } from "@/dentlab/src/components/ui/label";
import {
	InputWrapper,
	INVALID_CONTROL_CLASS,
} from "@/dentlab/src/components/input-wrapper";
import { cn } from "@/dentlab/src/lib/util";
import { getPatientDebtorProblems } from "@/dentlab/src/store/Jobs/utils";

export const JobInfoPatientIsPaying: React.FC<{
	disabled: boolean;
	inputHeight?: number;
	validationError?: string | null;
}> = ({ disabled, inputHeight, validationError }) => {
	const { patientIsPaying, updateJob, job, setFieldProblems } = useJobStore(
		(state) => ({
			patientIsPaying: state.job?.is_paid_by_patient,
			updateJob: state.updateJob,
			job: state.job,
			setFieldProblems: state.setFieldProblems,
		})
	);
	const { getPatient } = usePatientStore((state) => ({
		getPatient: state.getPatient,
	}));

	const handlePatientIsPayingChange = async (value: boolean) => {
		// Show a warning if the patient is not ready to export an invoice
		if (!job?.patient_id) {
			showNotification({
				message: "Es wurde kein Patient ausgewählt",
				type: "warning",
			});
		} else {
			const patient = await getPatient(job.patient_id);
			if (!patient) {
				showNotification({
					message: "Patient nicht gefunden",
					type: "warning",
				});
			} else {
				const problems = value ? getPatientDebtorProblems(patient) : [];
				setFieldProblems(job.id, "patient-paying-toggle", problems);
				if (problems.length > 0) {
					showNotification({
						message:
							"Die Adressdaten des Patienten sind nicht vollständig.",
						type: "warning",
					});
				}
			}
		}

		const success = await updateJob("is_paid_by_patient", value);
		if (!success) {
			showNotification({
				message: "Fehler beim Aktualisieren des Auftrags",
				type: "error",
			});
		}
	};

	return (
		<InputWrapper
			validationError={validationError}
			className="flex flex-col justify-end h-full"
		>
			<div
				className={cn(
					"flex items-center space-x-2 border rounded-md px-3",
					validationError && INVALID_CONTROL_CLASS
				)}
				style={{ height: `${inputHeight ?? 48}px` }}
			>
				<Checkbox
					id="is_paid_by_patient"
					checked={patientIsPaying ?? false}
					onCheckedChange={(checked) =>
						handlePatientIsPayingChange(checked as boolean)
					}
					disabled={disabled}
					aria-label="Einzelrechnung an Patient"
					data-testid="checkbox-einzelrechnung-patient"
				/>
				<Label
					htmlFor="is_paid_by_patient"
					className="text-sm font-normal cursor-pointer"
				>
					Einzelrechnung an Patient
				</Label>
			</div>
		</InputWrapper>
	);
};
